import { render, staticRenderFns } from "./DetailBase.vue?vue&type=template&id=96a41c50&scoped=true&"
import script from "./DetailBase.vue?vue&type=script&lang=ts&"
export * from "./DetailBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a41c50",
  null
  
)

export default component.exports